import { createContext, Dispatch, SetStateAction } from "react";

export type AccountType = "free" | "standard" | "premium";

export type UserType = {
  firstName: string;
  accountType: AccountType;
  companyName: string;
  colorTheme: string;
};
type UserInfoType = {
  userInfo: UserType;
  setUserInfo: Dispatch<SetStateAction<UserType>>;
};

const initialState = {
  userInfo: {
    firstName: "",
    accountType: "free" as UserType["accountType"],
    companyName: "",
    colorTheme: "",
  },
  setUserInfo: () => null,
};

const UserContext = createContext<UserInfoType>(initialState);

export default UserContext;
